// FILE: client/src/reducers/subcategoryReducers.js

import * as S from "../constants/subcategoryConstants";

const subcategoryListInitialState = {
  subcategories: [],
  page: 1,
  pages: 1,
  count: 0,
};

const subcategoryDetailsInitialState = {
  subcategory: null,
};

export const subcategoryListReducer = (
  state = subcategoryListInitialState,
  action,
) => {
  switch (action.type) {
    case S.SUBCATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case S.SUBCATEGORY_LIST_SUCCESS:
      return {
        loading: false,
        subcategories: action.payload?.subcategories || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 1,
        count: action.payload?.count || 0,
      };

    case S.SUBCATEGORY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case S.SUBCATEGORY_LIST_RESET:
      return subcategoryListInitialState;

    case S.SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const subcategoryDetailsReducer = (
  state = subcategoryDetailsInitialState,
  action,
) => {
  switch (action.type) {
    case S.SUBCATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case S.SUBCATEGORY_DETAILS_SUCCESS:
      return {
        loading: false,
        subcategory: action.payload || null,
      };

    case S.SUBCATEGORY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case S.SUBCATEGORY_DETAILS_RESET:
      return subcategoryDetailsInitialState;

    case S.SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminSubcategoryListReducer = (
  state = subcategoryListInitialState,
  action,
) => {
  switch (action.type) {
    case S.ADMIN_SUBCATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case S.ADMIN_SUBCATEGORY_LIST_SUCCESS:
      return {
        loading: false,
        subcategories: action.payload?.subcategories || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 1,
        count: action.payload?.count || 0,
      };

    case S.ADMIN_SUBCATEGORY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case S.ADMIN_SUBCATEGORY_LIST_RESET:
      return subcategoryListInitialState;

    case S.ADMIN_SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminSubcategoryDetailsReducer = (
  state = subcategoryDetailsInitialState,
  action,
) => {
  switch (action.type) {
    case S.ADMIN_SUBCATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case S.ADMIN_SUBCATEGORY_DETAILS_SUCCESS:
      return {
        loading: false,
        subcategory: action.payload || null,
      };

    case S.ADMIN_SUBCATEGORY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case S.ADMIN_SUBCATEGORY_DETAILS_RESET:
      return subcategoryDetailsInitialState;

    case S.ADMIN_SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminSubcategoryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case S.ADMIN_SUBCATEGORY_CREATE_REQUEST:
      return {
        loading: true,
      };

    case S.ADMIN_SUBCATEGORY_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        subcategory: action.payload || null,
      };

    case S.ADMIN_SUBCATEGORY_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case S.ADMIN_SUBCATEGORY_CREATE_RESET:
      return {};

    case S.ADMIN_SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminSubcategoryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case S.ADMIN_SUBCATEGORY_UPDATE_REQUEST:
      return {
        loading: true,
      };

    case S.ADMIN_SUBCATEGORY_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        subcategory: action.payload || null,
      };

    case S.ADMIN_SUBCATEGORY_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case S.ADMIN_SUBCATEGORY_UPDATE_RESET:
      return {};

    case S.ADMIN_SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminSubcategoryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case S.ADMIN_SUBCATEGORY_DELETE_REQUEST:
      return {
        loading: true,
      };

    case S.ADMIN_SUBCATEGORY_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
        id: action.payload?.id,
      };

    case S.ADMIN_SUBCATEGORY_DELETE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case S.ADMIN_SUBCATEGORY_DELETE_RESET:
      return {};

    case S.ADMIN_SUBCATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};
